import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function LayoutPreLoad() {

	const authFetching = useSelector(({ login }) => login.authFetching);

	useEffect(() => {
		if (!authFetching) {
			setTimeout(() => {
				window.jQuery('.loader').fadeOut();
				window.jQuery('.loader-mask').delay(300).fadeOut('slow');
			}, 500)
		}
	}, [authFetching])

	return (
		<div className='loader-mask'>
			<div className='loader'>"Loading..."</div>
		</div>
	);
}
